import React from "react";
import { Tag, Tooltip } from "antd";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { useTranslation } from "react-i18next";

/**
 * StatusBadge — icon + text + color status pill.
 * type="extraction": ML extraction quality (Good / verify / failed states)
 * type="updation": operator processing status (not_yet_started / in_progress / completed)
 */

const EXTRACTION_MAP = {
  Good: { color: "success", icon: <CheckCircleOutlined />, labelKey: "good" },
  "Please verify the excel once!": {
    color: "warning",
    icon: <ExclamationCircleOutlined />,
    labelKey: "verify",
  },
  invalid_file_format: {
    color: "error",
    icon: <CloseCircleOutlined />,
    labelKey: "not_extracted",
  },
  invalid_pet_invoice: {
    color: "error",
    icon: <CloseCircleOutlined />,
    labelKey: "not_extracted",
  },
  extraction_issue: {
    color: "error",
    icon: <CloseCircleOutlined />,
    labelKey: "not_extracted",
  },
};

const UPDATION_MAP = {
  not_yet_started: {
    color: "default",
    icon: <ClockCircleOutlined />,
    labelKey: "not_yet_started",
  },
  in_progress: {
    color: "processing",
    icon: <SyncOutlined />,
    labelKey: "in_progress",
  },
  completed: {
    color: "success",
    icon: <CheckCircleOutlined />,
    labelKey: "completed",
  },
};

const StatusBadge = ({ type = "extraction", status, tooltip, style }) => {
  const { t } = useTranslation();
  if (!status) return null;

  const map = type === "updation" ? UPDATION_MAP : EXTRACTION_MAP;
  const conf = map[status];

  if (!conf) {
    return (
      <Tag style={style} icon={<ExclamationCircleOutlined />}>
        {status}
      </Tag>
    );
  }

  const badge = (
    <Tag color={conf.color} icon={conf.icon} style={{ marginInlineEnd: 0, ...style }}>
      {t(conf.labelKey)}
    </Tag>
  );

  return tooltip ? <Tooltip title={tooltip}>{badge}</Tooltip> : badge;
};

export default StatusBadge;
